
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import "../css/LoginPage.css"; // Include a separate CSS file for styling
import { apiBaseUrl } from '../common';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${apiBaseUrl}/user/call-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username:email, password }),
      });

      const data = await response.json();

      console.log(data)
      if (response.ok && data.data.jT && data.data.eT) {
        login(data.data.jT, data.data.eT ); // Save the token in the context
        navigate('/'); // Redirect to the home page
      } else {
        setError(data.message || 'Invalid email or password');
      }
    } catch (error) {
      setError('Something went wrong. Please try again.');
    }
  };


  return (
    <div className="login-container">
      <div className="login-left">
        <img
          src="/og_web_guru_full_logo.png"
          alt="Og Web Guru"
          className="company-logo"
        />
      </div>
      <div className="login-right">
        <h1>Login</h1>
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label>UserName</label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your UserName"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          <button type="submit" className="submit-btn">
            Login
          </button>
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
